import { render, staticRenderFns } from "./a-add-to-wishlist.vue?vue&type=template&id=d41e852c&"
import script from "./a-add-to-wishlist.vue?vue&type=script&lang=js&"
export * from "./a-add-to-wishlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports